module.exports = {
    IO_ADDRESS: 'http://localhost:3001',
    MAPBOX_TOKEN: ''
}